import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { MethodOverview } from './components/MethodOverview';
import { MaterialPreview } from './components/MaterialPreview';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-12 md:py-20 text-center pt-[4px] pb-[4px]" data-id="element-0" data-mp="2whxb3sqftmf6">
    <p className="text-xl md:text-3xl font-display italic text-brand-purpleDark/85 leading-relaxed font-[800]" data-id="element-1" data-mp="28sl4n0mhvsgk">
      🌱 La próxima consulta puede ser diferente.
    </p>
  </div>;
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="leaf-canvas min-h-screen text-brand-text font-sans selection:bg-brand-greenLight/40 selection:text-brand-purpleDark" data-id="element-2" data-mp="3mkrc3gqhn9b7">
      <UrgencyBanner data-id="element-3" data-mp="3rd19fhtxnbni" />
      <Hero data-id="element-4" data-mp="3relwkmdx3sbc" />
      <InitialTestimonials data-id="element-5" data-mp="5or2zhbcs60" />
      <PainPoints data-id="element-6" data-mp="4wxfu7a14id" />
      <MethodOverview data-id="element-7" data-mp="5gg5d4r3wxg" />
      <MaterialPreview data-id="element-8" data-mp="7su7f7e1n58" />
      <MoreTestimonials data-id="element-9" data-mp="2zld259q0hfbj" />
      <Guarantee data-id="element-10" data-mp="2zm4zaoz9bl3x" />
      <FAQ data-id="element-11" data-mp="2zmo4d53t6f0j" />
      <CostComparison data-id="element-12" data-mp="2zmwh8wzxlkbq" />
      <TransitionPhrase data-id="element-13" data-mp="33mov9p83gioh" />
      <EmotionalClose data-id="element-14" data-mp="33m5e4aq9pybi" />
      <Footer data-id="element-15" data-mp="33nggc642ey0i" />
      <FloatingNotification data-id="element-16" data-mp="33mymfg4vkvvr" />
    </div>;
}